module.exports = __webpack_public_path__ + "static/media/badger-honey.b1a64d84.svg";